// extracted by mini-css-extract-plugin
export var button = "styles-module--button--b7bfc";
export var white = "styles-module--white--5b264";
export var whiteOutline = "styles-module--whiteOutline--9f157";
export var yellow = "styles-module--yellow--2c7a4";